import { OpenAPI, DashboardService, SupplierService } from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT

export const postReportingInvoiceOperations = DashboardService.getInvoicesOperationsReportDataDashboardInvoicesOperationsPost
export const postInvoiceComplexityReport = DashboardService.getInvoiceComplexityReportDataDashboardInvoiceComplexityPost
export const postBusinessUnitDashboardReport = DashboardService.buDashboardDashboardBusinessUnitPost
export const postSupplierDashboardReport = DashboardService.supplierDashboardDashboardSupplierPost
export const getBusinessUnitGlobalFilter = DashboardService.businessUnitNameListDashboardBusinessUnitNameGet
export const getSAupplierNameGlobalFilter = DashboardService.supplierNameListDashboardSupplierNameGet
export const postTeamAndReviwerDashBoardRpt = DashboardService.teamReviewerDashboardDashboardTeamReviewerPost
export const getDashBoardInvoiceStatusList = DashboardService.invoiceStatusListDashboardInvoiceStatusListGet
export const getDashBoardRejectionReasonList = DashboardService.invoiceRejectionreasonListDashboardInvoiceRejectionreasonListGet
export const getDashBoardInvoiceTypeList = DashboardService.invoiceInvoicetypeListDashboardInvoiceInvoicetypeListGet
export const getTeamsListsDashboardTeamsList = DashboardService.teamsListsDashboardTeamsListGet

export const getAllSuppliers = SupplierService.getAllSuppliersSuppliersAllGet